module.exports = __webpack_public_path__ + "public/img/arrow-l.0e4ff56e.svg";